import { createContext, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react';
import { Channel, useConfigStore } from 'scbk-services/config';
import { getPlatformByDevice } from 'scbk-services/utils/deviceUtils';

/**
 * 채널 컨텍스트 Props
 */
interface ChannelContextProps {
    channel?: Channel;
    setChannel: React.Dispatch<React.SetStateAction<Channel>>;
}

/**
 * 채널 컨텍스트 생성
 */
const ChannelContext = createContext<ChannelContextProps | null>(null);

/**
 * 채널 컨텍스트 hook
 * @returnss
 */
const useChannelContext = () => {
    const context = useContext(ChannelContext);
    if (!context) throw new Error('useChannelContext must be used within ChannelContextProvider');
    return context;
};

type ChannelContextProviderProps = {
    loading: React.ReactNode;
} & PropsWithChildren;

/**
 * 앱 초기 실행 시 채널(IB/SB/MB)를 판단
 * 채널이 결정되기전까지 children을 랜더링 하지 않는다.
 * @param param0
 * @returns
 */
const ChannelContextProvider: React.FC<ChannelContextProviderProps> = ({
    loading: Loading,
    children,
}) => {
    const [channel, setChannel] = useState<Channel>(() => getPlatformByDevice() as Channel);

    useEffect(() => {
        if (!channel) {
            return;
        }
        //config store에 확정된 채널정보를 설정한다.
        useConfigStore.getState().setChannel(channel);

        console.log(`### ChannelContextProvider 확정된 채널정보 [${channel}]`);
    }, [channel]);

    const value = useMemo(
        () => ({
            channel,
            setChannel,
        }),
        [channel],
    );

    if (!channel) {
        // TODO 채널정보가 확정이 안된경우.. 로딩처리..
        return Loading;
    }

    return <ChannelContext.Provider value={value}>{children}</ChannelContext.Provider>;
};

export { ChannelContextProvider, useChannelContext };
